import React from "react";
import { get } from "lodash";

import { mobileScreenType } from "@stadium/constants";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { appendBackgroundImage } from "@sendmagic/prismic-nextjs/src/helpers/images";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const defaultArr = [];

const TextOnlyBannerVersionTwo = ({ doc, StartOrderBtn, currentDevice }) => {
  const {
    heading,
    subheading,
    background_image,
    internal_link_id,
    bg_video,
    mobile_background_image,
    mobile_only_header_img,
  } = doc?.primary || {};

  const backgroundImageUrl = background_image?.url;
  const mobileImageUrl = mobile_background_image?.url || mobile_only_header_img?.url;

  const imageUrl = currentDevice == mobileScreenType ? mobileImageUrl : backgroundImageUrl;

  const buttonDesign = ["solid_background", "transparent_background"];

  const sectionStyle = appendBackgroundImage(imageUrl);

  const containerClass = `position-relative py-md-5 py-4 text-banner-section prismic-slice ${
    bg_video?.url && "video-bg-slice"
  }`;

  const items = get(doc, "items", defaultArr);

  return (
    <div
      className={`position-relative py-md-5 py-4 text-banner-section prismic-slice ${containerClass}`}
      style={sectionStyle}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-absolute d-block" />
      )}
      {bg_video?.url && (
        <div className="video-bg-container">
          <video
            className="video-bg"
            poster={background_image?.url}
            autoPlay="autoplay"
            muted="muted"
            loop="loop"
          >
            <source src={bg_video?.url} />
          </video>
        </div>
      )}
      <div className="container py-5 py-2xl-5 text-center text-banner-container">
        <div className="row py-5 py-2xl-5">
          <div className="col-lg-8 mx-auto pb-5 pb-2xl-5">
            <div className="fs-3 fs-md-24 mobile-fs-24  font-weight-bold text-program-yellow">
              {textResolver(heading)}
            </div>
            <div className="fs-1-2 mobile-fs-13 font-weight-bold text-white ls-1 py-5 py-2xl-5">
              {textResolver(subheading)}
            </div>

            <div className="row justify-content-center">
              {items.map(({ link, link_text, start_an_order, button_design }, idx) => {
                const linkClassName = buttonDesign.includes(button_design) ? "button" : "";
                return (
                  <div key={`program-index-${idx}`} className="col-auto pb-5 pb-2xl-5">
                    {start_an_order && StartOrderBtn ? (
                      <StartOrderBtn
                        className={`${linkClassName} btn button-program-green program-common-button`}
                      >
                        {textResolver(link_text)}
                      </StartOrderBtn>
                    ) : (
                      link?.url && (
                        <PrismicLinkTag urlText={link_text} url={link?.url} target={link?.target} />
                      )
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextOnlyBannerVersionTwo;
